// initial state
const state = () => ({
  option_1: [],
  label_option_1: "Testing Label 1",
  empty_option_1: "Testing Empty 1",
  active_option_1: {},
  default_option_1: {},
  option_2: [],
  label_option_2: "Testing Label 2",
  empty_option_2: "Testing Empty 2",
  active_option_2: {},
  default_option_2: {},
  option_3: [],
  label_option_3: "Testing Label 3",
  empty_option_3: "Testing Empty 3",
  active_option_3: {},
  default_option_3: {},
});

// getters
const getters = {
  getOptions: (state) => {
    return {
      option_1: state.option_1,
      option_2: state.option_2,
      option_3: state.option_3,
    };
  },
  getOptionValue: (state) => (key, value) => {
    if (state[key]) {
      return state[key].find((option) => option == value);
    }
    return undefined;
  },
  getOption: (state) => (key) => {
    if (state[key]) {
      return state[key];
    }
    return undefined;
  },
  getActiveOption: (state) => (key) => {
    if (state[`active_${key}`]) {
      return state[`active_${key}`];
    }
    return undefined;
  },
  getActiveOptions: (state) => {
    return {
      "option_1":state.active_option_1,
      "option_2":state.active_option_2,
      "option_3":state.active_option_3,
    };
  },
  getDefaultOption: (state) => (key) => {
    if (state[`default_${key}`]) {
      return state[`default_${key}`];
    }
    return undefined;
  },
  getLabel: (state) => (key) => {
    if (state[`label_${key}`]) {
      return state[`label_${key}`];
    }
    return undefined;
  },
  getEmpty: (state) => (key) => {
    if (state[`empty_${key}`]) {
      return state[`empty_${key}`];
    }
    return undefined;
  },
};

// actions
const actions = {
  setOptions({ commit }, options) {
    commit("setOptions", { options });
  },
  setLabels({ commit }, labels) {
    commit("setLabels", { labels });
  },
  setEmpties({ commit }, empties) {
    commit("setEmpties", { empties });
  },
  activateOption({ commit }, { option, key }) {
    commit("activateOption", { option, key: `active_${key}` });
  },
  setDefaultOption({ commit }, { size, key }) {
    commit("setDefaultOption", { size, key: `default_${key}` });
  },
  setLabel({ commit }, { label, key }) {
    commit("setLabel", { label, key: `label_${key}` });
  },
  setEmpty({ commit }, { empty, key }) {
    commit("setEmpty", { empty, key: `empty_${key}` });
  },
};

// mutations
const mutations = {
  setOptions(state, { options }) {
    Object.keys(options).forEach((key) => {
      if (options[key].length) {
        const optionCopy = [...options[key]];
        // NOTE I'm not sure this needs to be sorted
        // optionCopy.sort((a, b) => {
        //   const aInt = parseInt(a);
        //   const bInt = parseInt(b);
        //   return aInt < bInt ? -1 : bInt === aInt ? 0 : 1;
        // });
        state[key] = optionCopy;
      }
    });
  },
  setLabels(state, { labels }) {
    Object.keys(labels).forEach((key) => {
      if (labels[key].length) {
        state[key] = labels[key];
      }
    });
  },
  setEmpties(state, { empties }) {
    Object.keys(empties).forEach((key) => {
      if (empties[key].length) {
        state[key] = empties[key];
      }
    });
  },
  activateOption(state, { option, key }) {
    if (key in state) {
      state[key] = option;
    }
  },
  setDefaultOption(state, { size, key }) {
    if (key in state) {
      state[key] = size;
    }
  },
  setLabel(state, { label, key }) {
    if (key in state) {
      state[key] = label;
    }
  },
  setEmpty(state, { empty, key }) {
    if (key in state) {
      state[key] = empty;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
